module.exports = __webpack_public_path__ + "static/media/discovery-park-logo.ee2a7d97.png";